import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import DetailsBox from '../../../../../components/Cards/DetailsBox'
import API from '../../../../../services/API'
import moment from 'moment'
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import AddNewClient from '../../../../clients/AddNewClient'
import BigModal from '../../../../../components/Modals/BigModal'
import AddNewEvent from '../../../AddNewEvent'

const EventClientPanel = ({
  selectedEvent,
  setSelectedEvent,
  selectedOrganisation,
  setSelectedOrganisation,
  eventRef,
  setEventRef,
  hasExistingEvent,
}) => {
  const [organisationOptions, setOrganisationOptions] = useState([])
  const [eventOptions, setEventOptions] = useState([])

  const [createNewOrganisation, setCreateNewOrganisation] = useState(false)
  const [createNewEvent, setCreateNewEvent] = useState(false)

  const loadOptions = (newID) => {
    if (!newID?.event && !hasExistingEvent) {
      API.get('/event-org-options').then((res) => {
        setOrganisationOptions(res.data)
        if (newID?.client) {
          setSelectedOrganisation(res.data.find((x) => x._id === newID.client))
        }
      })
    }
    if (selectedOrganisation && !hasExistingEvent) {
      API.get('/events-by-organisation?orgID=' + selectedOrganisation._id).then(
        (res) => {
          setEventOptions(res.data)
          if (res.data.length === 0) setCreateNewEvent(true)
        }
      )
    }
  }
  useEffect(() => {
    loadOptions()
  }, [selectedOrganisation])

  return (
    <Paper sx={{ padding: 1 }}>
      <Stack gap={1}>
        <Typography variant="title3">Event</Typography>
        <Autocomplete
          options={organisationOptions}
          getOptionLabel={(option) => option.orgName}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          value={selectedOrganisation}
          disabled={hasExistingEvent}
          onChange={(e, value) => {
            setSelectedOrganisation(value)
            setSelectedEvent(null)
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Client"
              required
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {params.InputProps.endAdornment}

                    <InputAdornment position="end">
                      {!selectedOrganisation && (
                        <Tooltip title="Add a New Client">
                          <IconButton
                            onClick={() => {
                              setSelectedOrganisation(null)
                              setCreateNewOrganisation(true)
                            }}
                          >
                            <AddCircleIcon color="anGreen" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </InputAdornment>
                  </>
                ),
              }}
            />
          )}
          noOptionsText={
            <Alert severity="error">
              <AlertTitle>No Client Found</AlertTitle>
              <Button
                onClick={() => setCreateNewOrganisation(true)}
                variant="contained"
                size="small"
                fullWidth
              >
                Add New
              </Button>
            </Alert>
          }
        />
        <BigModal
          open={createNewOrganisation}
          onClose={() => setCreateNewOrganisation(false)}
        >
          <AddNewClient
            customCallbackAction={(newClient) => {
              setCreateNewOrganisation(false)
              setCreateNewEvent(true)
              loadOptions({ client: newClient.newID })
            }}
          />
        </BigModal>
        {selectedOrganisation && (
          <Stack direction="row" gap={1}>
            <Autocomplete
              sx={{ flex: 1 }}
              options={[...eventOptions]}
              getOptionLabel={(option) =>
                option.title +
                ' ' +
                moment(option.startDate).format('(Do MMM YYYY)')
              }
              isOptionEqualToValue={(option, value) => option._id === value._id}
              value={selectedEvent}
              disabled={hasExistingEvent}
              onChange={(e, value) => setSelectedEvent(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Event"
                  required
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {params.InputProps.endAdornment}
                        <InputAdornment position="end">
                          {!selectedEvent && (
                            <Tooltip title="Add a New Event">
                              <IconButton
                                onClick={() => {
                                  setSelectedEvent(null)
                                  setCreateNewEvent(true)
                                }}
                              >
                                <AddCircleIcon color="anGreen" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </InputAdornment>
                      </>
                    ),
                  }}
                />
              )}
            />
          </Stack>
        )}
        <BigModal
          open={createNewEvent}
          onClose={() => setCreateNewEvent(false)}
        >
          <AddNewEvent
            orgName={selectedOrganisation}
            customCallbackFunction={(newID) => {
              setCreateNewEvent(false)
              API.get(
                '/events-by-organisation?orgID=' + selectedOrganisation._id
              ).then((res) => {
                setEventOptions(res.data)
                setSelectedEvent(res.data.find((x) => x._id === newID))
              })
            }}
          />
        </BigModal>
      </Stack>
    </Paper>
  )
}

export default EventClientPanel
